var $ = require('jquery');
var DocNote = require('../document');
var fvChannel = require('glRadio').channel('FV');


module.exports = DocNote.extend({

    ViewConstructor: require('../../../views/note/flash/flashNote'),
    desc: "Flash Note",
    actionTitle: 'Flash Note',
    init: "F",
    iconClass: "icon-flash", //icon-clock

    createHotKey: 'l',

    /*
    * Fetch individually on open.
    * Note: fetch WILL ALSO DELETE from the database.
    * */
    getFlashNoteContentAndDestroyOnServer: function() {

        var docNotesUrl = fvChannel.request('apiUrl').docNotes( this.collection.document );

        return $.ajax({
            url: docNotesUrl + '/text/' + this.get('sequence'),
            type: 'GET',
            dataType: 'text' // DVBC-1746 -- override global setting
        });

    },

    /*
    * These are never destroyed by sending an http request.
    * Destroy will be called to:
    * 1) delete new note view sent to other user
    * 2) remove the note view after it's been opened ( opening will get the text, and destory it on the server )
    * Don't send an http request.
    * Just trigger the destory event that will be listened to on all collections (so it's removed from them).
    * Also -- employ success and error callbacks so this can be called from the same 'workflow' as other note models.
    * Somewhat hacky solution for DVBC-1620 -- fixes without intruding into the workflow, which would be complicated.
    * Note: this is synchronous and doesn't return and xhr; -- shouldn't matter for this use case.
    * */
    destroy: function(options) {

        this.trigger('destroy', this, this.collection, options);

        if (options.success) {
            options.success(this, {}, options);
            return;
        }

        // Should never reach here -- but left in case
        if (options.error) {
            options.error && options.error(this, {}, options);
            return;
        }

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/noteTypes/flash.js
 ** module id = 279
 ** module chunks = 0
 **/